export const generateMaskImage = (path: string) =>
  `url("data:image/svg+xml,%3Csvg width='298rem' height='257rem' viewBox='0 0 298 257' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${path}' fill='black'/%3E%3C/svg%3E")`
